export const CREATE_GDPR_OPT_OUT_REQUEST = 'GDPROptOutPage/CREATE_GDPR_OPT_OUT_REQUEST';
export const CREATE_GDPR_OPT_OUT_SUCCESS = 'GDPROptOutPage/CREATE_GDPR_OPT_OUT_SUCCESS';
export const CREATE_GDPR_OPT_OUT_FAILURE = 'GDPROptOutPage/CREATE_GDPR_OPT_OUT_FAILURE ';
